import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

export const leaderProfileExportAPI = createApi({
  reducerPath: 'leaderProfileExportAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  tagTypes: ['ProfileExport'],
  endpoints: (builder) => ({
    getLeaderProfileExportData: builder.query<any, leaderProfileExportArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/export`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'ProfileExport', id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
  }),
});

export const { useGetLeaderProfileExportDataQuery, useLazyGetLeaderProfileExportDataQuery } =
  leaderProfileExportAPI;
